"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function Ecosystemsynergy() {
  const headline = "We curate digital identity, not just visuals.";
  const words = headline.split(" ");
  const tenets = [{
    numeral: "i",
    title: "Precision",
    body: "Every pixel serves a purpose. We eliminate the superfluous to reveal the essential."
  }, {
    numeral: "ii",
    title: "Clarity",
    body: "We prioritize intuitive navigation. Complexity should never hinder the user experience."
  }, {
    numeral: "iii",
    title: "Legacy",
    body: "A brand is a long-term commitment. We build systems designed to evolve and endure."
  }];
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: tenetsRef,
    isVisible: tenetsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: blockARef,
    isVisible: blockAVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: blockBRef,
    isVisible: blockBVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: blockCRef,
    isVisible: blockCVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return;
}